export default "__VITE_ASSET__DTbIDQov__"